import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full bg-white border-t border-gray-200 py-10" aria-label="Footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="text-lg font-bold text-blue-600">Badminton Stats</Link>
            <p className="text-sm text-gray-500 mt-2">AI-powered match tracker, video coaching, and training diary for badminton players.</p>
          </div>
          {/* Features */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Explore</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/features" className="text-gray-500 hover:text-blue-600 transition-colors">Features</Link></li>
              <li><Link to="/leaderboard" className="text-gray-500 hover:text-blue-600 transition-colors">Leaderboard</Link></li>
              <li><Link to="/blog" className="text-gray-500 hover:text-blue-600 transition-colors">Blog & Tips</Link></li>
              <li><Link to="/features#ai-coach" className="text-gray-500 hover:text-blue-600 transition-colors">AI Video Coach</Link></li>
              <li><Link to="/features#training-diary" className="text-gray-500 hover:text-blue-600 transition-colors">Training Diary</Link></li>
            </ul>
          </div>
          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="text-gray-500 hover:text-blue-600 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-500 hover:text-blue-600 transition-colors" data-testid="footer-terms-link">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-100 pt-6 text-center text-gray-500 text-sm">
          &copy; 2026 Badminton Stats. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
